module.exports = __webpack_public_path__ + "img/okx_new.ddbbc19b.svg";